import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Globals, Reset } from '@icecreamsocial/components';
import ThemeProvider from './providers/ThemeProvider';
import { Main } from './views/Main';
import { Snackbar } from './presentational';

const Subscriptions = () => {
	return (
		<ThemeProvider>
			<Globals />
			<Reset />
			<Snackbar>
				<Main />
			</Snackbar>
		</ThemeProvider>
	);
};
export default observer(Subscriptions);
